// 子路由下的其他应用
export default [
    {
        name: "待选课程",
        path: "/CourseSelectionWaiting",
        component: () => import( '@/views/otherApp/courseSelection/waiting.vue'),
    },
    {
        name: "已选课程",
        path: "/courseSelectionSelected",
        component: () => import( '@/views/otherApp/courseSelection/selected.vue'),
    },
]